import React, { useLayoutEffect, useState, useRef } from "react";
import Modal from "./modal";
import StatusChoiceModal from "./statusChoiceModal";
import DiagnosticModal from "./DiagnosticModal";
import './ReproStyle.css'
import { updateReproduction } from "../../../api/reproductionApi";
import './ReproWheel.css'
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { markDoneA, updateSupprimeEventA, updateTodoTask, updateTodoTaskA } from "../../../api/todoApi";
import repro from '../../../cow.jpg';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const statusColors = {
    "Vêlage": "#ff2911ff",
    'Avortement': '#000000ff',
    "Saillie": "#f1c40f",
    "Oestrus": "#f1c40f",
    "Gestation": "#0746f3f0",
    "Repos": "#27ae60",
};

const arabStatus = [
    "الولادة",
    'الاجهاض',
    "التلقيح",
    "التلقيح بالعجل",
    "الحمل",
    "الراحة"
]



const ringRadius = 500;
const circumference = 2 * Math.PI * ringRadius;

const segments = [
    {
        label: "Repos",
        color: "#27ae60",
        value: 60.5 / 365
    }, {
        label: "Vêlage",
        color: "#ff2911ff",
        value: 83 / 365
    },
    {
        label: "Saillie",
        color: "#f1c40f",
        value: 89 / 365
    },
    {
        label: "Gestation",
        color: "#0746f3f0",
        value: 144 / 365
    },
];

const phaseStartDay = {
    "Avortement": 0,
    "Vêlage": 0,
    "Saillie": 84,
    "Oestrus": 84,
    "Gestation": 84,
    "Repos": 84
};

const phaseLength = {
    "Avortement": 360,
    "Vêlage": 360,
    "Saillie": 360,
    "Oestrus": 360,
    "Gestation": 360,
    "Repos": 360
};

function daysBetween(from, to) {
    return Math.floor((to - from) / (1000 * 60 * 60 * 24));
}

function getMonthAngle(dateString) {
    const d = new Date(dateString);
    const year = d.getFullYear();
    const startOfYear = new Date(year, 0, 1);

    const dayOfYear = Math.floor((d - startOfYear) / (1000 * 60 * 60 * 24)) + 1;

    return (dayOfYear / 365) * 360;
}

function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

function getRelevantDate(reproduction) {
    const status = reproduction.status?.titre;

    switch (status) {
        case "Vêlage":
            return reproduction.date_velage || reproduction.date_saille || reproduction.date_gestation;
        case "Avortement":
            return reproduction.date_avortement || reproduction.date_velage || reproduction.date_saille || reproduction.date_gestation;
        case "Saillie":
            return reproduction.date_saille || reproduction.date_gestation || reproduction.date_velage;
        case "Oestrus":
            return reproduction.date_saille || reproduction.date_gestation || reproduction.date_velage;
        case "Gestation":
            return reproduction.date_gestation || reproduction.date_saille;
        case "Repos":
            return reproduction.date_gestation || reproduction.date_saille;
        default:
            return reproduction.date_gestation || reproduction.date_saille || reproduction.date_velage;
    }
}

export default function ReproWheel({ reproductions, onStatusChange }) {
    const radius = 450;
    const center = 510;
    const today = new Date();
    const todayDateString = today.toISOString().split('T')[0];
    const todayAngle = getMonthAngle(todayDateString);
    const rotationAngle = 181.5 - todayAngle;

    const [selected, setSelected] = useState(null);
    const [showChoiceModal, setShowChoiceModal] = useState(false);
    const [showDiagnostic, setShowDiagnostic] = useState(false);

    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    const containerRef = useRef(null);
    const svgRef = useRef(null);
    const navigate = useNavigate();

    const countOlderAnimals = (reproductions, today) => {
        let count = 0;
        reproductions.forEach((r) => {
            const dateN = new Date(r.animal.date_naissance);
            if (isNaN(dateN)) return;
            const daysOld = (today - dateN) / (1000 * 60 * 60 * 24);
            if (daysOld > 365 && r.status.titre !== 'croissance') count += 1;
        });
        return count;
    };


    const handleMouseDown = (e) => {
        if (e.button === 0) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - pan.x,
                y: e.clientY - pan.y
            });
        }
    };

    const handleWheel = (e) => {
        if (!e.ctrlKey) return;
        e.preventDefault();

        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const delta = e.deltaY * -0.001;
        const newZoom = Math.min(Math.max(0.5, zoom + delta), 2);

        const zoomPoint = {
            x: (mouseX - pan.x) / zoom,
            y: (mouseY - pan.y) / zoom
        };

        const newPan = {
            x: mouseX - zoomPoint.x * newZoom,
            y: mouseY - zoomPoint.y * newZoom
        };

        setZoom(newZoom);
        setPan(newPan);
    };

    const handleMouseMove = (e) => {
        if (isDragging) {
            let newX = e.clientX - dragStart.x;
            let newY = e.clientY - dragStart.y;
            setPan({ x: newX, y: newY });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    function openPopup(repro) {
        setSelected(repro);
    }

    function closePopup() {
        setSelected(null);
    }

    function handleChangeStatus(repro) {
        setSelected(repro);
        setShowChoiceModal(true);
    }

    function onSelectNext(next) {
        if (!selected || !selected.id) {
            return;
        }
        setShowChoiceModal(false);

        //  DIAGNOSTIC
        if (next === "Diagnostic") {
            const saillieDate = new Date(selected.date_saille);
            const todayDate = new Date();
            const saillieDay = saillieDate.setHours(0, 0, 0, 0);
            const todayDay = todayDate.setHours(0, 0, 0, 0);

            if (saillieDay === todayDay) {
                swal('Erreur', 'On ne peut pas faire le diagnostic le jour de la saillie.', 'error');
                return;
            }
            setShowDiagnostic(true);
            return;
        }

        if (next === "Saillie" || next === "Oestrus") {
            if (!selected.date_velage) {
                executeStatusChange(next);
                return;
            }

            const velageDate = new Date(selected.date_velage);
            velageDate.setHours(0, 0, 0, 0);
            const todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);

            const daysSinceVelage = Math.floor((todayDate - velageDate) / (24 * 60 * 60 * 1000));

            if (daysSinceVelage < 83) {
                swal({
                    title: "Alert",
                    text: `L'animal n'a pas passé 83 jours après le vêlage (${daysSinceVelage} jours). Voulez-vous quand même continuer ?`,
                    icon: "warning",
                    buttons: ["Non", "Oui"],
                    dangerMode: true,
                }).then((willContinue) => {
                    if (willContinue) {
                        executeStatusChange(next);
                    } else {
                        setShowChoiceModal(false);
                        setSelected(null);
                    }
                });
                return;
            }
            executeStatusChange(next);
            return;
        }

        if (next === "Vêlage") {
            if (selected.date_gestation) {
                const gestationDate = new Date(selected.date_gestation);
                gestationDate.setHours(0, 0, 0, 0);
                const todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);

                if (gestationDate.getTime() === todayDate.getTime()) {
                    swal('Erreur', 'Pas possible d\'avoir vêlage le jour de la gestation.', 'error');
                    return;
                }
            }

            swal({
                title: "Nouveau Animal!",
                text: "Voulez-vous ajouter l'animal ?",
                icon: "success",
                buttons: ["Non merci", "Oui"],
            }).then((willAdd) => {
                if (willAdd) {
                    executeStatusChange(next).then(() => {
                        navigate('/admin/add-animal/' + selected.animal.id);
                    });
                } else {
                    swal("Tu peux l'ajouter quand tu veux!");
                    executeStatusChange(next);
                }
            });
            return;
        }

        if (next === "Supprimer événement") {
            swal({
                title: "Confirmer la suppression",
                text: "Êtes-vous sûr de vouloir supprimer cet événement ?",
                icon: "warning",
                buttons: ["Annuler", "Supprimer"],
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    executeStatusChange("previous");
                } else {
                    setShowChoiceModal(false);
                    setSelected(null);
                }
            });
            return;
        }
        executeStatusChange(next);
    }

    function executeStatusChange(status) {
        if (!selected || !selected.id) {
            return Promise.reject('No selected item');
        }

        return onStatusChange(selected.id, status)
            .then(() => {
                setShowChoiceModal(false);
                setSelected(null);
                swal('Succès', 'Statut mis à jour avec succès', 'success');
            })
            .catch(err => {
                console.error("Change status failed:", err.response?.data || err.message || err);
                swal('Erreur', 'Impossible de changer le statut', 'error');
                setShowChoiceModal(false);
            });
    }

    function onDiagnosticResult(result) {
        const id = selected?.id;

        setShowDiagnostic(false);
        setSelected(null);

        if (result === "positif") {
            let referenceDate;
            if (selected.date_saille) {
                referenceDate = new Date(selected.date_saille);
            } else if (selected.date_gestation) {
                referenceDate = new Date(selected.date_gestation);
            } else {
                referenceDate = new Date();
            }

            const prevuVelageDate = new Date(referenceDate.getTime() + (283 * 24 * 60 * 60 * 1000));
            const formattedPrevuVelage = prevuVelageDate.toISOString().split('T')[0];

            let gestationDate;
            if (selected.date_saille) {
                gestationDate = selected.date_saille;
            } else if (selected.date_gestation) {
                gestationDate = selected.date_gestation;
            } else {
                gestationDate = new Date().toISOString().split('T')[0];
            }

            updateReproduction(id, {
                date_gestation: gestationDate,
                date_prevu_velage: formattedPrevuVelage
            })
                .then(() => {
                    return onStatusChange(id, "Gestation");
                })
                .then(() => {
                    swal('Succès', 'Diagnostic positif confirmé', 'success');
                })
                .catch(err => {
                    console.error("Update failed:", err);
                    swal('Erreur', 'Impossible de mettre à jour', 'error');
                });
        } else {
            onStatusChange(id, "Vêlage", true)
                .then(() => {
                    swal('Info', 'Diagnostic négatif', 'info');
                })
                .catch(err => {
                    console.error("Status change failed:", err);
                    swal('Erreur', 'Impossible de changer le statut', 'error');
                });
        }
    }
    const btnStyle = {
        padding: "10px 15px",
        marginLeft: "20px",
        background: "#3498db",
        border: "none",
        borderRadius: "5px",
        color: "white",
        cursor: "pointer",
        textDecoration: "none",
    };

    return (
        <>

            <Modal show={!!selected} onClose={closePopup}>
                {selected && (
                    <div>
                        <h2>Détails de l'animal</h2>
                        <p><b>Numéro :</b> {selected.animal.numero}</p>
                        <p><b>Nom :</b> {selected.animal.nom}</p>
                        <p><b>Status :</b> {selected.status.titre}</p>
                        <p><b>Date Vêlage :</b> {selected.date_velage || '(Pas encore de velage)'}</p>
                        <p><b>Date Saillie :</b> {selected.date_saille || '(Pas encore de saillie)'}</p>
                        <p><b>Date Gestation :</b> {selected.date_gestation || '(Pas encore de gestation)'}</p>
                        <p><b>Date Prevu Vêlage :</b> {(selected.status.titre == 'Repos' || selected.status.titre == 'Gestation') ? selected.date_prevu_velage || '(Pas encore de prevu velage)' : '(Pas encore de prevu velage)'}</p>
                        <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                            <a href={"/admin/animal/details/" + selected.animal.id} style={btnStyle}>Détails</a>
                            <a href={"/admin/edit/" + selected.animal.id} style={btnStyle}>Modifier</a>
                            <button type="button" onClick={() => { handleChangeStatus(selected); }} style={btnStyle}>Changer Status</button>
                        </div>
                    </div>
                )}
            </Modal>

            <StatusChoiceModal
                show={showChoiceModal}
                currentStatus={selected?.status?.titre}
                onSelect={onSelectNext}
                onClose={() => setShowChoiceModal(false)}
            />

            <DiagnosticModal
                show={showDiagnostic}
                onResult={onDiagnosticResult}
                onClose={() => setShowDiagnostic(false)}
            />


            <strong className="todayDate">
                <label>date :</label> {todayDateString} <br />
                <label> Nombre de Reproductions :</label>  {countOlderAnimals(reproductions, today)} / {reproductions.length}
            </strong>
            <div
                style={{ cursor: isDragging ? "grabbing" : "grab" }}
                onWheel={handleWheel}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}

            >

                <div
                    style={{
                        width: "100%",
                        height: "110%",
                        borderRadius: "8px",
                        background: "#fff",
                        overflow: "hidden",
                    }}>
                    <svg
                        ref={svgRef}
                        viewBox="-200 0 1513 1300"
                        preserveAspectRatio="xMidYMid meet"
                        className="repro-wheel-svg"
                        style={{
                            marginTop: '100px',
                            maxHeight: '800px',
                            transform: `translate(${pan.x}px) `,
                            transformOrigin: "center center",
                            transition: isDragging ? "none" : "transform 0.1s ease-out"
                        }}
                    >


                        {(() => {
                            let dashOffset = 0;
                            const todayStartAngle = 30.3;
                            const todayStartAngleRec = 30;

                            return (
                                <g>
                                    <g transform={`rotate(${todayStartAngle}, ${center}, ${center})`}>{segments.map((seg, i) => {
                                        const dash = seg.value * circumference;
                                        const element = (
                                            <circle
                                                key={i}
                                                cx={center}
                                                cy={center}
                                                r={ringRadius}
                                                fill="none"
                                                stroke={seg.color}
                                                strokeWidth="22"
                                                strokeLinecap="butt"
                                                strokeDasharray={`${dash} ${circumference}`}
                                                strokeDashoffset={-dashOffset}
                                            />
                                        );
                                        dashOffset += dash;
                                        return element;
                                    })}</g>
                                    <g transform={`rotate(${todayStartAngleRec}, ${center}, ${center})`}>

                                        {(() => {
                                            const labeledIndices = [0, 6, 12, 18, 21, 24, 29, 33, 37];
                                            const labeled = ['60 jours \n-\n Avant La velage ', '30', '', '30', '45', '60', '83 Jours\n-\n Saillie', '21 Jours \n-\n Possible Retours\n a oestrus', '40 jours\n-\n Diagnostique'];
                                            return Array.from({ length: 72 }, (_, i) => {
                                                const angle = i * 5;
                                                let x = center + ringRadius * Math.cos(angle * Math.PI / 180);
                                                let y = center + ringRadius * Math.sin(angle * Math.PI / 180);
                                                const elements = [
                                                    <rect
                                                        key={i}
                                                        x={x - 10}
                                                        y={y - 2.5}
                                                        width="20"
                                                        height="3"
                                                        fill="black"
                                                        transform={`rotate(${angle}, ${x}, ${y})`}
                                                    />
                                                ];
                                                if (labeledIndices.includes(i)) {
                                                    const textRadius = ringRadius + 90;
                                                    let LineRadius = ringRadius + 60;
                                                    let textX = center + textRadius * Math.cos(angle * Math.PI / 180);
                                                    let textY = center + textRadius * Math.sin(angle * Math.PI / 180);
                                                    let lineX = center + LineRadius * Math.cos(angle * Math.PI / 180);
                                                    let lineY = center + LineRadius * Math.sin(angle * Math.PI / 180);

                                                    const labelIndex = labeledIndices.indexOf(i);
                                                    if (labelIndex === 6) {
                                                        y = center + 30 + ringRadius * Math.sin(angle * Math.PI / 180);
                                                        x = center + 10 + ringRadius * Math.cos(angle * Math.PI / 180);
                                                        lineX = center + 20 + LineRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    if (labelIndex === 8) {
                                                        lineX = center + 20 + LineRadius * Math.cos(angle * Math.PI / 180);
                                                        textX = center - 15 + textRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    if (labelIndex === 0) {
                                                        lineX = center - 20 + LineRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    if (labelIndex === 7) {
                                                        lineX = center + 20 + LineRadius * Math.cos(angle * Math.PI / 180);
                                                        lineY = center - 10 + LineRadius * Math.sin(angle * Math.PI / 180);
                                                        textX = center - 20 + textRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    if (labelIndex === 2) {
                                                        LineRadius = ringRadius + 30;
                                                        lineX = center + LineRadius * Math.cos(angle * Math.PI / 180);
                                                        lineY = center + LineRadius * Math.sin(angle * Math.PI / 180);
                                                        y = center + ringRadius * Math.sin(angle * Math.PI / 180);
                                                        x = center + ringRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    elements.push(<>
                                                        {labelIndex === 2 && <line x1={lineX + 12} y1={lineY - 6.5} x2={x + 1} y2={lineY + 9} stroke="#640303ff" strokeWidth="2" />}
                                                        <line x1={lineX} y1={lineY} x2={x} y2={y} stroke={labelIndex === 2 ? "#640303ff" : '#000000ff'} strokeWidth={labelIndex === 2 ? "#fc0404ff" : '#000000ff'} />
                                                        <text
                                                            key={`text-${i}`}
                                                            x={textX}
                                                            y={textY}
                                                            fontSize="15"
                                                            textAnchor="middle"
                                                            alignmentBaseline="middle"
                                                            fill="black"
                                                            transform={`rotate(${-todayStartAngleRec}, ${textX}, ${textY})`}
                                                        >
                                                            {labeled[labelIndex].split('\n').map((line, i) => (
                                                                <tspan x={textX} dy={i === 0 ? 0 : 12}>{line}</tspan>
                                                            ))}
                                                        </text></>
                                                    );
                                                }
                                                return elements;
                                            });
                                        })()}
                                    </g>
                                </g>
                            );
                        })()}

                        <circle
                            cx={center}
                            cy={center}
                            r={radius}
                            fill="white"
                            stroke="#333"
                            strokeWidth="3"
                        />

                        {(() => {
                            const angle = 90;
                            const x = center + (radius - 40) * Math.cos(angle * Math.PI / 180);
                            const y = center + (radius - 40) * Math.sin(angle * Math.PI / 180);

                            return (
                                <g>
                                    <line x1={x} y1={y + 40} x2={center} y2={center} stroke="#ff0000ff" />
                                    <line x1={x} y1={y + 40} x2={center} y2={center} stroke="#ff0000ff" />
                                    <text x={x} y={y + 140} fontSize="20" textAnchor="middle" fill="red">
                                        Aujourd'hui
                                    </text>
                                </g>
                            );
                        })()}

                        <g transform={`rotate(${rotationAngle}, ${center}, ${center})`}>
                            {monthNames.map((m, i) => {
                                const angle = i * 30 - 90;
                                const x = center + radius * Math.cos(angle * Math.PI / 180);
                                const y = center + radius * Math.sin(angle * Math.PI / 180);
                                const textX = center + (radius + 20) * Math.cos(angle * Math.PI / 180);
                                const textY = center + (radius + 20) * Math.sin(angle * Math.PI / 180);

                                return (
                                    <g key={i}>
                                        <line x1={center} y1={center} x2={x} y2={y} stroke="#bbb" strokeWidth="1" />
                                        <text
                                            x={textX}
                                            y={textY}
                                            fontSize="12"
                                            textAnchor="middle"
                                            alignmentBaseline="middle"
                                            transform={`rotate(${-rotationAngle}, ${textX}, ${textY})`}
                                        >
                                            {m}
                                        </text>
                                    </g>
                                );
                            })}

                            {monthNames.map((m, i) => {
                                const year = today.getFullYear();
                                const daysInMonth = getDaysInMonth(year, i);
                                const monthStartAngle = i * 30 - 90;
                                const dayAngleStep = 30 / daysInMonth;

                                return Array.from({ length: Math.floor(daysInMonth / 5) }, (_, j) => {
                                    const day = (j + 1) * 5;
                                    const angle = monthStartAngle + ((day - 1) * dayAngleStep);
                                    const x1 = center + (radius - 60) * Math.cos(angle * Math.PI / 180);
                                    const y1 = center + (radius - 60) * Math.sin(angle * Math.PI / 180);
                                    const x2 = center + (radius - 80) * Math.cos(angle * Math.PI / 180);
                                    const y2 = center + (radius - 80) * Math.sin(angle * Math.PI / 180);
                                    const textX = center + (radius - 90) * Math.cos(angle * Math.PI / 180);
                                    const textY = center + (radius - 90) * Math.sin(angle * Math.PI / 180);

                                    return (
                                        <g key={`${i}-${day}`}>
                                            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#ccc" strokeWidth="1" />
                                            <text
                                                x={textX}
                                                y={textY}
                                                fontSize="8"
                                                textAnchor="middle"
                                                alignmentBaseline="middle"
                                                fill="#666"
                                                transform={`rotate(${-rotationAngle}, ${textX}, ${textY})`}
                                            >
                                                {day}
                                            </text>
                                        </g>
                                    );
                                });
                            })}

                            {(() => {
                                const animalsByAngle = new Map();

                                reproductions.forEach((r, index) => {
                                    if (!r?.animal || !r?.status) return;

                                    const dateN = new Date(r.animal.date_naissance);
                                    const dateNDiff = (today - dateN) / (1000 * 60 * 60 * 24);

                                    if (dateNDiff < 365 || (!r.date_saille && !r.date_gestation && !r.date_velage && !r.date_avortement) || r.status.titre === 'croissance') return;

                                    const relevantDate = getRelevantDate(r);
                                    if (!relevantDate) return;

                                    const startDate = new Date(relevantDate);
                                    const diffDays = Math.max(0, daysBetween(startDate, today));

                                    const status = r.status.titre;
                                    const phaseStart = phaseStartDay[status] || 0;
                                    const currentPhaseLength = phaseLength[status] || 0;

                                    const insideSegment = Math.min(diffDays, currentPhaseLength);
                                    const cycleDay = phaseStart + insideSegment;
                                    const angle = (cycleDay / 365) * 360 + todayAngle - 91;
                                    const GROUPING_THRESHOLD = 15;
                                    const angleKey = Math.round(angle / GROUPING_THRESHOLD) * GROUPING_THRESHOLD;

                                    if (!animalsByAngle.has(angleKey)) {
                                        animalsByAngle.set(angleKey, []);
                                    }

                                    animalsByAngle.get(angleKey).push({
                                        reproduction: r,
                                        angle: angle,
                                        status: status,
                                        index: index
                                    });
                                });

                                const elements = [];

                                animalsByAngle.forEach((animals, angleKey) => {
                                    const count = animals.length;

                                    animals.forEach((animal, posIndex) => {
                                        const { reproduction: r, angle, status, index } = animal;

                                        let radiusOffset = 0;
                                        if (count > 1) {
                                            const spacing = 35;
                                            radiusOffset = ((posIndex - (count) / 2) * spacing);
                                        }

                                        const adjustedRadius = radius - 40 + radiusOffset;
                                        const x = center + adjustedRadius * Math.cos(angle * Math.PI / 180);
                                        const y = center + adjustedRadius * Math.sin(angle * Math.PI / 180);
                                        const color = statusColors[status] || "#e67e22";

                                        elements.push(
                                            <g key={index} onClick={() => openPopup(r)} style={{ cursor: "pointer" }}>
                                                <circle cx={x} cy={y} r="15" fill={color} stroke="#000" strokeWidth="2" />
                                                <text
                                                    x={x}
                                                    y={y + 5}
                                                    fontSize="12"
                                                    textAnchor="middle"
                                                    fill="white"
                                                    transform={`rotate(${-rotationAngle}, ${x}, ${y})`}
                                                >
                                                    {r.animal?.numero}
                                                </text>
                                            </g>
                                        );
                                    });
                                });

                                return elements;
                            })()}
                        </g>
                        <defs>
                            <clipPath id="circleClip">
                                <circle cx={center} cy={center} r="50" />
                            </clipPath>
                        </defs>

                        <image
                            href={repro}
                            x={center - 80}
                            y={center - 50}
                            width="160"
                            clipPath="url(#circleClip)"
                            preserveAspectRatio="xMidYMid slice"
                        />
                    </svg>
                </div>

                <div className="key-reproduction-div" style={{
                    marginTop: "20px",
                    textAlign: "left",
                    fontSize: "calc(12px + 0.5vw)",
                    justifyContent: "flex-start",
                    gap: "10px",
                    width: "100%"
                }}>
                    {Object.entries(statusColors).map(([label, color], index) => (
                        <div key={label} style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                            <span style={{
                                width: "calc(20px + 1vw)",
                                height: "calc(20px + 1vw)",
                                backgroundColor: color,
                                borderRadius: "3px",
                                marginRight: "8px",
                                flexShrink: 0,
                            }}></span>
                            <span style={{ fontSize: "calc(10px + 0.5vw)" }}>{label} - {arabStatus[index]}</span>
                        </div>
                    ))}
                </div>
            </div >

        </>

    );
}